import styles from './BetterTag.module.scss';

const COLOR_MAP = {
    primary:    'var(--azul500)',
    success:    'var(--ui-success)',
    danger:     'var(--ui-danger)',
    warning:    'var(--ui-warning)',
    neutral:    'var(--ui-neutral)',
    info:       'var(--ui-info)',
    dark:       'var(--ui-dark)',
    amber:      'var(--ui-amber)',
    muted:      'var(--ui-muted)',
    'dark-red': 'var(--ui-dark-red)',
    silver:     'var(--ui-silver)',
    pink:       'var(--ui-pink)',
    orange:     'var(--ui-orange)',
};

export default function BetterTag({ type, color, textColor, style, children, onClick }) {
    const bgColor = color || COLOR_MAP[type] || COLOR_MAP.neutral;
    const txtColor = textColor || (type === 'silver' ? 'var(--text-secondary)' : 'var(--branco)');

    return (
        <span
            className={styles.tag}
            style={{ backgroundColor: bgColor, color: txtColor, cursor: onClick ? 'pointer' : 'default', ...style }}
            onClick={onClick}
        >
            {children}
        </span>
    );
}
